document.addEventListener("DOMContentLoaded", function () {
  const form = document.getElementById("klaviyo-form");
  const messageDiv = document.getElementById("klaviyo-message");

  // Add null checks to prevent errors
  if (!form || !messageDiv) {
    console.warn("Klaviyo form elements not found");
    return;
  }

  form.addEventListener("submit", async function (e) {
    e.preventDefault();

    const emailInput = form.querySelector('input[name="email"]');
    const button = form.querySelector('button[type="submit"]');

    // Add null checks for form elements
    if (!emailInput || !button) {
      console.error("Required form elements not found");
      return;
    }

    const email = emailInput.value;
    const originalButtonContent = button.innerHTML;

    // Disable button and show loading state
    button.disabled = true;
    button.innerHTML = '<span class="loading-spinner"></span>';

    try {
      const formData = new FormData(form);
      const response = await fetch(form.action, {
        method: "POST",
        body: formData,
        headers: {
          Accept: "application/json",
        },
      });

      const data = await response.json();

      if (data.success) {
        // Show success message
        messageDiv.className =
          "newsletter-form__message newsletter-form__message--success";
        messageDiv.innerHTML = `
          Thank you for subscribing!
        `;
        messageDiv.style.display = "block";

        // Clear the form
        form.reset();
      } else {
        throw new Error(data.message || "Subscription failed");
      }
    } catch (error) {
      // Show error message
      messageDiv.className = "newsletter-form__message form__message";
      messageDiv.innerHTML = `
        ${error.message || "There was an error subscribing. Please try again."}
      `;
      messageDiv.style.display = "block";
    } finally {
      // Re-enable button and restore original content
      button.disabled = false;
      button.innerHTML = originalButtonContent;
    }
  });
});
